<div>
  <div class="mb-3">
    <span class="view-main-title">
      Cargar información operación
    </span>
  </div>

  <div>
    <div *ngIf="order" class="mt-3">
      <app-detail-order-card [importOrderInformation]="order" [showDetails]="true"/>
    </div>

    <div class="custom-tabview mt-3">
      <p-tabView [(activeIndex)]="tabActiveIndex">
        <p-tabPanel header="Cargar y asignar documentos">
          <div class="pb-4">
            <div>
              <h3>Carga y asignación de documentos</h3>
            </div>

            <div class="flex gap-4 align-items-stretch">
              <div class="card flex flex-column flex-1">
                <span class="font-medium text-base">Carga documentos desde tus archivos</span>
                <span class="text-sm">
                  Selecciona los documentos que necesites cargar, con un máximo de 5 archivos por carga.
                </span>
                <app-file-upload-custom
                  class="w-full mt-4"
                  [fullWidth]="true"
                  (onFilesUpload)="onSelect($event)"/>
              </div>

              <div class="card flex flex-column flex-1">
                <span class="font-medium text-base">Asigna documentos desde Fruzty a esta orden</span>
                <span class="text-sm">
                  Selecciona documentos disponibles en Fruzty y asígnalos a esta orden.
                </span>

                <div class="mt-4 w-full flex flex-1 pb-3">
                  <p-button
                    severity="primary"
                    (onClick)="visibleDocumentAssignModal = true"
                    styleClass="w-full h-full"
                    class="custom-text-button w-full">
                    <div class="flex flex-column gap-2 w-full justify-items-center text-center">
                      <i class="pi pi-link text-white text-2xl"></i>
                      <span class="text-bold">Asignar documentos disponibles en Fruzty</span>
                    </div>
                  </p-button>
                </div>
              </div>
            </div>

            <!-- TODO aleyton: Se ocultan los botones Regresar y Subir dado que no tienen una función específica por el momento -->
            <!-- <div class="flex flex-row flex-wrap">
              <div class="flex gap-2 col-12 p-fluid">
                <div class="col-2">
                  <p-button label="Regresar" (onClick)="goToOrderDetail()" [loading]="loading"
                    styleClass="p-button-outlined"></p-button>
                </div>
                <div class="col-2">
                  <p-button label="Subir" (onClick)="uploadDialog()" [loading]="loading"></p-button>
                </div>
              </div>
            </div> -->
          </div>
        </p-tabPanel>
        <p-tabPanel header="Documentos cargados y asignados">
          <div class="pb-4">
            <h3>Documentos cargados y asignados</h3>
          </div>

          <div class="field col-12">
            <p-table
              [value]="documents" responsiveLayout="stack"
              [breakpoint]="'600px'"
              class="loaded-docs-table">
              <ng-template pTemplate="header">
                <tr>
                  <th>
                    <div class="flex justify-content-center align-items-center">Nombre documento</div>
                  </th>
                  <th>
                    <div class="flex justify-content-center align-items-center">Tipo de documento</div>
                  </th>
                  <th>
                    <div class="flex justify-content-center align-items-center">Origen</div>
                  </th>
                  <th>
                    <div class="flex justify-content-center align-items-center">Fecha de creación</div>
                  </th>
                  <th>
                    <div class="flex justify-content-center align-items-center">Fecha de asignación</div>
                  </th>
                  <th>
                    <div class="flex justify-content-center align-items-center">Estado validación</div>
                  </th>
                  <th>
                    <div class="flex justify-content-center align-items-center">Acciones</div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-document>
                <tr>
                  <td style="cursor: pointer;" (click)="getOperationDocument(document.guid)">
                    <div class="flex justify-content-start align-items-center">
                      <span class="pi pi-file mr-1 document-text"></span>
                      <span class="document-text">{{ document.name }}</span>
                    </div>
                  </td>
                  <td>
                    <p-dropdown
                      [options]="operationDocumentTypes"
                      optionLabel="name"
                      optionValue="id"
                      [ngModel]="document.operationDocumentTypeId"
                      (ngModelChange)="setSelectedDocumentType(document, $event)"
                      [placeholder]="'AdminDownloadedDocuments.Table.DocumentTypePlaceholder' | translate"
                      class="custom-dropdown"
                      appendTo="body"
                      [style]="{'width': '15rem'}">
                    </p-dropdown>
                  </td>
                  <td>
                    <div class="flex justify-content-center">
                      {{ document.documentEmailReadId ? 'Asignado' : 'Cargado' }}
                    </div>
                  </td>
                  <td>
                    <div class="flex justify-content-center">{{ document.created | date:'dd-MM-yyyy HH:mm' }}</div>
                  </td>
                  <td>
                    <div class="flex justify-content-center">{{ document.created | date:'dd-MM-yyyy HH:mm' }}</div>
                  </td>
                  <td>
                    <div class="flex justify-content-center" *ngIf="document.documentValidationResult; else noValidation">
                      <div *ngIf="document.documentValidationResult.score ==
                            document.documentValidationResult.expectedScore && document.documentValidationResult.score != 0"  class="cell-style">
                          Comprobado
                      </div>
                      <div *ngIf="document.documentValidationResult.score <
                            document.documentValidationResult.expectedScore && document.documentValidationResult.score != 0 "  class="cell-style">
                         Parc.Comprobado
                      </div>
                      <div *ngIf="document.documentValidationResult.score == 0"  class="cell-style">
                          No comprobado
                      </div>
                    </div>

                    <ng-template #noValidation>
                      <div class="flex justify-content-center">
                        No validado
                      </div>
                    </ng-template>
                  </td>
                  <td>
                    <div class="flex justify-content-center gap-1">
                      <p-button
                        [disabled]="!document.documentValidationResult"
                        pTooltip="Ver resultados"
                        icon="pi pi-eye" styleClass="p-button"
                        (onClick)="openResults(document.log)"
                        class="table-button-validate">
                      </p-button>
                      <p-button
                        [disabled]="!document.operationDocumentType.hasValidationConfig"
                        pTooltip="Validar documento"
                        icon="pi pi-key" styleClass="p-button"
                        [loading]="loading"
                        (onClick)="ValidateDocument(document.guid, document.isForwarderDocument, document.isQcDocument)"
                        class="table-button-validate">
                      </p-button>
                      <p-button
                        pTooltip="{{ 'ForwarderPage.ForwarderUserOriginReview.ButtonDelete' | translate }}"
                        icon="pi pi-trash" styleClass="p-button"
                        (onClick)="onDelete(document.guid)" [disabled]="loading"
                        class="table-button-delete">
                      </p-button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between" *ngIf="documents.length === 0">
                  {{ 'DocumentComponent.EmptyResult' | translate }}
                </div>
              </ng-template>
            </p-table>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Historial documentos de orden">
          <div class="pb-4">
            <h3>Historial documentos de orden</h3>
          </div>

          <div class="field col-12">
            <p-table
              [value]="documentsHistory"
              responsiveLayout="stack"
              [breakpoint]="'600px'"
              class="loaded-docs-table">
              <ng-template pTemplate="header">
                <tr>
                  <th>
                    <div class="flex justify-content-center align-items-center">Nombre documento</div>
                  </th>
                  <th>
                    <div class="flex justify-content-center align-items-center">Tipo de documento</div>
                  </th>
                  <th>
                    <div class="flex justify-content-center align-items-center">Origen</div>
                  </th>
                  <th>
                    <div class="flex justify-content-center align-items-center">Fecha de creación</div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-document>
                <tr>
                  <td style="cursor: pointer;" (click)="getOperationDocument(document.guid)">
                    <div class="flex justify-content-start align-items-center">
                      <span class="pi pi-file mr-1 document-text"></span>
                      <span class="document-text">{{ document.name }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="flex justify-content-center">
                      {{ document.operationDocumentType?.name }}
                    </div>
                  </td>
                  <td>
                    <div class="flex justify-content-center" *ngIf="!document.rejected">
                      {{ document.documentEmailReadId ? 'Asignado' : 'Cargado' }}
                    </div>
                    <div class="flex justify-content-center" *ngIf="document.rejected">
                      {{ 'Rechazado' }}
                    </div>
                  </td>
                  <td>
                    <div class="flex justify-content-center">{{ document.created | date:'dd-MM-yyyy HH:mm' }}</div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between" *ngIf="documentsHistory.length === 0">
                  {{ 'DocumentComponent.EmptyResult' | translate }}
                </div>
              </ng-template>
            </p-table>
          </div>
        </p-tabPanel>

      </p-tabView>
    </div>
  </div>
</div>

<p-confirmDialog acceptLabel="Aceptar" rejectLabel="Cancelar" rejectButtonStyleClass="p-button-outlined"
  [style]="{width: '50vw'}"></p-confirmDialog>
<p-dialog header="Selecciona el tipo de documento" [(visible)]="visibleFilesModal" [modal]="true" [draggable]="false"
  [style]="{width: '50vw'}">
  <p>Selecciona el o los tipos de documentos que corresponden a los archivos cargados.</p>
  <div class="flex flex-row flex-wrap" *ngFor="let file of uploadedFiles; let i = index">
    <div class="flex align-items-center justify-content-start m-2 col-3">
      <input pInputText type="text" placeholder="Nombre del documento" [value]="names[i]" style="width: 100%;" />
    </div>
    <div class="flex align-items-center justify-content-start m-2 col-3">
      <p-dropdown [options]="operationDocumentTypes" placeholder="Tipo de documento de operación"
        (onChange)="onSelectDocumentTypeMultiple($event, i)" appendTo="body" styleClass="mb-2" optionLabel="name"
        optionValue="id">
      </p-dropdown>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button  styleClass="p-button-outlined"
      label="Cerrar"
      (onClick)="visibleFilesModal = false"></p-button>
    <p-button label="Cargar" (onClick)="uploadMultiple()"></p-button>
  </ng-template>
</p-dialog>
<p-dialog header="Resultados palabras claves" [(visible)]="visibleKeywordResult" [modal]="true" [draggable]="false" [style]="{width: '50vw'}">
  <div class="flex justify-content-center align-items-center">
    <div class="col-12">
      <textarea pInputTextarea [(ngModel)]="log" [autoResize]="true" style="width: 100%;" ></textarea>
    </div>
  </div>
<!-- <p-table
class="loaded-docs-table"
[value]="results"
>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="2">
        <div class="flex justify-content-center align-items-center">
          Sin resultados encontrados
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th>
         <div class="flex justify-content-center align-items-center">
           Palabra clave
          </div>
        </th>

      <th>
        <div class="flex justify-content-center align-items-center">
          Resultado
        </div>
      </th>
    </tr>
  </ng-template>
  <ng-template let-result pTemplate="body" >
    <tr>
      <td>
        <div class="flex justify-content-center align-items-center">
          {{result.keyword}}
        </div>
      </td>
      <td>

      </td>
    </tr>
  </ng-template>
</p-table> -->
</p-dialog>

<p-dialog
  header="Asignar documentos disponibles en Fruzty"
  [(visible)]="visibleDocumentAssignModal"
  [modal]="true"
  [draggable]="false"
  [style]="{width: '80vw'}"
  class="document-assign-dialog">

  <div *ngIf="visibleDocumentAssignModal" class="flex flex-column">
      <app-downloaded-documents-table
        [modalMode]="true"
        [importOrderInformation]="order"
        [orderId]="orderGuid"
        [order] ="order"
        [operationDocumentTypes]="operationDocumentTypes"
        (selectionWithTypesChanged)="onDocumentSelectionWithTypesChanged($event)">
      </app-downloaded-documents-table>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      (click)="closeDocumentAssignModal()"
      label="Cancelar"
      styleClass="p-button-outlined"
      class="custom-text-button"/>

    <p-button
      (click)="assignSelectedDocuments()"
      label="Asignar"
      [disabled]="selectedDocumentsWithTypes.length === 0"
      class="custom-text-button"/>
  </ng-template>
</p-dialog>
